import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';
export var AddAddressModal = function AddAddressModal(props) {
  var renderAddressForm = props.renderAddressForm,
      _a = props.addressType,
      addressType = _a === void 0 ? 'company' : _a,
      disclosure = props.disclosure;
  var isOpen = disclosure.isOpen,
      onClose = disclosure.onClose;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    blockScrollOnMount: false,
    isCentered: true
  }, /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(ModalContent, {
    fontFamily: "body",
    width: "540px"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, addressType === 'company' ? 'ที่อยู่สำหรับออกใบกำกับภาษีสำหรับนิติบุคคล' : 'ที่อยู่สำหรับออกใบกำกับภาษีสำหรับบุคคลธรรมดา'), /*#__PURE__*/React.createElement(ModalCloseButton, null), /*#__PURE__*/React.createElement(ModalBody, {
    pb: 6
  }, renderAddressForm && renderAddressForm({
    onClose: onClose,
    addressType: addressType
  }))));
};